module.exports = __webpack_public_path__ + "media/react/components/PatientBox/RentalStatus/assets/btn-picker-d153077468ca789cfc153bcc5a575e07.svg";